var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 54,
    viewBox: "0 0 86 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.25 0H10.75C7.89892 0 5.16462 1.13785 3.1486 3.16325C1.13259 5.18864 0 7.93566 0 10.8L0 43.2C0 46.0643 1.13259 48.8114 3.1486 50.8368C5.16462 52.8621 7.89892 54 10.75 54H75.25C78.1011 54 80.8354 52.8621 82.8514 50.8368C84.8674 48.8114 86 46.0643 86 43.2V10.8C86 7.93566 84.8674 5.18864 82.8514 3.16325C80.8354 1.13785 78.1011 0 75.25 0ZM21.5 29.7H16.125V35.1H10.75V29.7H5.375V24.3H10.75V18.9H16.125V24.3H21.5V29.7ZM59.125 10.8V43.2H26.875V10.8H59.125ZM72.5625 33.75C71.2337 33.75 69.9347 33.3541 68.8298 32.6124C67.7249 31.8707 66.8637 30.8165 66.3552 29.5831C65.8467 28.3497 65.7136 26.9925 65.9728 25.6831C66.2321 24.3738 66.872 23.171 67.8116 22.227C68.7513 21.283 69.9484 20.6402 71.2517 20.3797C72.555 20.1192 73.906 20.2529 75.1337 20.7638C76.3613 21.2747 77.4107 22.1399 78.1489 23.2499C78.8872 24.3599 79.2812 25.665 79.2812 27C79.2812 28.7902 78.5734 30.5071 77.3134 31.773C76.0534 33.0388 74.3444 33.75 72.5625 33.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicon9);
export default __webpack_public_path__ + "static/media/micon_9.905ba28605ea3f76d005613dec509cca.svg";
export { ForwardRef as ReactComponent };